import React, { useCallback } from 'react';
import moment from 'moment';

import PipelineIcon from '../../../assets/icons/PipelineIcon';
import StarCircleIcon from '../../../assets/icons/StarCircleIcon';

import { leadStatuses } from '../../../constants/sales';

import './surgeon-page.scss';

const SurgeonPipeline = (props) => {
  const { leads = [], pipelines = [], stages = [], users = [], onLeadClick } = props;

  const getPipelineTitle = useCallback((pipelineId) => {
    const pipeline = pipelines.find((p) => p.id === pipelineId);
    return pipeline?.title || '';
  }, [pipelines]);

  const getStageTitle = useCallback((stageId) => {
    const stage = stages.find((s) => s.id === stageId);
    return stage?.title || '';
  }, [stages]);

  const getUserName = useCallback((userId) => {
    const user = users?.find((u) => u.uid === userId);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [users]);

  const getStatusClassName = useCallback((lead) => {
    switch (lead.status) {
      case leadStatuses.WON.value:
        return 'surgeon-pipeline__surgeon-pipeline-item--won';
      case leadStatuses.LOST.value:
        return 'surgeon-pipeline__surgeon-pipeline-item--lost';
      default:
        return 'surgeon-pipeline__surgeon-pipeline-item--open';
    }
  }, []);


  return (
    <div className="surgeon-pipeline__container">
      <div className='d-flex space-between p-t-md p-b-md p-l-lg p-r-md'>
        <div className='d-flex'>
          <PipelineIcon color="var(--app-text)" />
          <div className='m-l-md font-bold font-size-lg'>
            Pipeline
          </div>
        </div>
        <div />
      </div>
      <div className='surgeon-pipeline__surgeon-pipeline-list'>
        {leads?.length ? (
          leads?.map((item) => (
            <div
              key={item.id}
              className={`surgeon-pipeline__surgeon-pipeline-item ${getStatusClassName(item)}`}
              onClick={() => onLeadClick(item.id)}
            >
              <div className='d-flex space-between'>
                {item.status === leadStatuses.WON.value ? (
                  <div className='m-b-sm'>
                    <StarCircleIcon color="var(--app-text)" />
                  </div>
                ) : (
                  <div className='font-bold font-size-lg'>{item.title}</div>
                )}
                <div className='font-size-sm secondary'>
                  {`Added ${moment(item.createdAt).local().fromNow()}`}
                </div>
              </div>
              {item.status !== leadStatuses.WON.value && (
                <div className='m-t-md'>
                  {getPipelineTitle(item.pipeline)}
                </div>
              )}
              <div className='m-t-md'>
                {getStageTitle(item.stage)}
              </div>
              <div className='m-t-md font-size-sm'>
                {`Assigned to ${getUserName(item.owner)}`}
              </div>
            </div>
          ))
        ) : (
          <div className='p-lg font-size-bg font-bold secondary d-flex flex-center'>
            No Leads
          </div>
        )}
      </div>
    </div>
  );
};

export default SurgeonPipeline;
